import { findMatchingVariant } from '@/util/findMatchingProductVariant';
import { isProductConfigurable } from '@/util/isProductConfigurable';
import { useMemo } from 'react';

const getFinalPriceAndRegularPrice = (product, optionCodes, optionSelections) => {
  let value;

  const { variants } = product;
  const isConfigurable = isProductConfigurable(product);

  const optionsSelected = Array.from(optionSelections.values()).filter(value => !!value).length > 0;

  if (!isConfigurable || !optionsSelected) {
    value = {
      finalPrice: product.prices?.finalPrice.value,
      regularPrice: product.prices?.regularPrice.value,
    };
  } else {
    const item = findMatchingVariant({
      optionCodes,
      optionSelections,
      variants,
    });

    value = {
      // finalPrice: item?.product.prices?.finalPrice,
      // regularPrice: item?.product.prices?.regularPrice,
      finalPrice: item?.product?.price_range?.minimum_price?.final_price.value,
      regularPrice: item?.product?.price_range?.maximum_price?.regular_price.value,
    };
  }

  return value;
};

export const useFinalPriceAndRegularPrice = ({
  product,
  optionCodes,
  optionSelections,
}: {
  product: any;
  optionCodes: any;
  optionSelections: any;
}) => {
  const finalPriceAndRegularPrice = useMemo(
    () => getFinalPriceAndRegularPrice(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections],
  );

  return {
    finalPriceAndRegularPrice,
  };
};
